<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Cadastro</span>
    </div>

    <div class="component-box container-fluid">
        <div class="row">
            <div class="col-12 component-title pt-4">Novo Departamento</div>
            <!-- <div class="col-12 form-subtitle pb-4">Dados</div> -->
            <form [formGroup]="departamentoFormGroup" #departamentoForm="ngForm" (ngSubmit)="onSubmit(departamentoFormGroup.value)" class="col-12">
                <div class="py-2 container-fluid">

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <div class="custom-pr-5">
                                <div class="custom-input-container">
                                    <input formControlName="nome" id="nome" class="custom-input-outline" type="text" />
                                    <label class="custom-label-outline label-required" for="nome">Nome:</label>
                                </div>
                                <div *ngIf="form.nome.invalid && (form.nome.dirty || form.nome.touched)" class="text-danger">
                                    <div *ngIf="form.nome.errors.required">
                                        Nome é obrigatório
                                    </div>
                                    <div *ngIf="form.nome.errors.maxlength">
                                        Nome deve conter no máximo 100 caracteres
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <div class="custom-pr-5">
                                <div class="custom-input-container">
                                    <input formControlName="codigo" id="codigo" class="custom-input-outline" type="text" />
                                    <label class="custom-label-outline label-required" for="codigo">Código:</label>
                                </div>
                                <div *ngIf="form.codigo.invalid && (form.codigo.dirty || form.codigo.touched)" class="text-danger">
                                    <div *ngIf="form.codigo.errors.required">
                                        Código é obrigatório
                                    </div>
                                    <div *ngIf="form.codigo.errors.maxlength">
                                        Código deve conter no máximo 15 caracteres
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row button-container mt-5 mb-3">
                        <div class="col-12 text-right">
                            <button type="submit" class="custom-button-full">Cadastrar</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
